// extracted by mini-css-extract-plugin
export default {"imageContainer":"I_-z","summaryPar":"J_-z","ratingCategories":"K_-z","reviewerInfo":"L_-z","reviewTypes":"M_-z","expanded":"N_-z"};